import { Nullable } from "common/records";
import { List, Record } from "immutable";
import { max, min } from "underscore";

export const queryFilter = (records: List<Nullable<Record<any>>>, query: string, property: string) => {
  return records.filter((record) => {
    return record?.get(property).toLowerCase().includes(query.toLowerCase());
  });
};

// Takes a List of records and DropResult and returns new List with sort_order set and dirty ids
// Breaks out indices to support other libraries besides react-beautiful-dnd
export const onSortEnd = (
  recordList: List<any>,
  oldIndex: number,
  newIndex: number,
  attrPath: string[] = ["sort_order"],
): { list: List<any>; dirtyIds: List<any> } => {
  const moving = recordList.get(oldIndex);
  let dirtyIds = List();

  const minIndex = min([oldIndex, newIndex]);
  const maxIndex = max([oldIndex, newIndex]);

  const setByAttrPath = attrPath.length > 0;
  let sorted: List<any>;
  if (setByAttrPath) {
    sorted = recordList.map((l) => l.getIn(attrPath)).sortBy((l) => l);
  }

  recordList = recordList
    .delete(oldIndex)
    .insert(newIndex, moving)
    .map((record, idx) => {
      if (idx >= minIndex && idx <= maxIndex) {
        dirtyIds = dirtyIds.push(record.id).toSet().toList();
        if (setByAttrPath) {
          return record.setIn(attrPath, sorted.get(idx));
        }
      }

      return record;
    });

  return { list: recordList, dirtyIds: dirtyIds };
};

/**
 * Checks if a record has changed
 *
 * @param {Record<any> | List<Record<any>>} current The current record
 * @param {Record<any> | List<Record<any>>} lastSaved The last saved record
 * @returns {boolean} True if the record has changed, false otherwise
 */
export const recordChanged = (
  current: Record<any> | List<Record<any>>,
  lastSaved: Nullable<Record<any>> | List<Nullable<Record<any>>>,
): boolean => {
  if (!lastSaved) {
    return true;
  }
  if (current.equals(lastSaved)) {
    return false;
  } else {
    return true;
  }
};

export const isDirty = (current: Nullable<Record<any>>, lastSaved: Nullable<Record<any>>): boolean => {
  // Return false if comparing undefined states
  if (current === undefined && lastSaved === undefined) {
    return false;
  }

  // Do not consider loading state as dirty
  return !current?.set("loading", false).equals(lastSaved?.set("loading", false));
};
